/* export all environment variables */
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const FABRIC_ENDPOINT = process.env.REACT_APP_FABRIC_ENDPOINT;
export const FABRIC_ACCESS_KEY = process.env.REACT_APP_FABRIC_ACCESS_KEY;